import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';

const TikTokIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and About */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
            <Link to="/" className="block mb-6">
              <img 
                src="/logo.png?id1" 
                alt="Québec Alimentation Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-600 mb-6">
              Viandes de qualité premium de fermes locales, livrées à votre porte.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-custom-green transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/recipes" className="text-gray-600 hover:text-custom-green transition-colors">
                  Recettes
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-custom-green transition-colors">
                  Contactez-nous
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-600 hover:text-custom-green transition-colors">
                  Réserver
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-custom-green flex-shrink-0 mt-1" />
                <span className="text-gray-600">
                  255 rue Duncan Mill<br />
                  Québec, QC<br />
                  Canada
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-custom-green" />
                <a 
                  href="tel:+14383793125" 
                  className="text-gray-600 hover:text-custom-green transition-colors"
                >
                  +1 438-379-3125
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-custom-red" />
                <a 
                  href="mailto:info@quebecalimentation.ca" 
                  className="text-gray-600 hover:text-custom-red transition-colors"
                >
                  info@quebecalimentation.ca
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61571813197475"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-custom-red text-white p-2 rounded-full hover:bg-opacity-90 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.tiktok.com/@neighborfood.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-custom-red text-white p-2 rounded-full hover:bg-opacity-90 transition-colors"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t mt-12 pt-8 text-center">
          <p className="text-gray-600">
            © {new Date().getFullYear()} Québec Alimentation. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 